import { render, staticRenderFns } from "./MenuOverlay.vue?vue&type=template&id=20d45679"
import script from "./MenuOverlay.vue?vue&type=script&lang=js"
export * from "./MenuOverlay.vue?vue&type=script&lang=js"
import style0 from "./MenuOverlay.vue?vue&type=style&index=0&id=20d45679&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navigation: require('/vercel/path0/components/elements/Navigation.vue').default,SocialMedia: require('/vercel/path0/components/elements/SocialMedia.vue').default})
